import * as React from 'react';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import NotListedLocationIcon from '@mui/icons-material/NotListedLocation';
import {
  Chip,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Collapse,
} from '@mui/material';
import { CourseCityDateItem } from './CourseCityDateItem';
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';

export const CourseCityItem = ({
  cc,
  canDeleteDates = false,
  canEditDates = false,
  canEditPublishedDates = false,
}) => {
  const [open, setOpen] = React.useState(false);

  const handleClick = () => {
    setOpen(!open);
  };

  const renderChip = () => {
    return (
      <>
        {cc.onDemand && (
          <Chip
            icon={<NotListedLocationIcon />}
            label={'On Demand'}
            size="small"
            color="info"
            sx={{ float: 'right', mr: '1em' }}
          />
        )}
      </>
    );
  };

  const renderIcon = () => {
    return cc.drupalId === null ? (
      <CloseIcon fontSize={'small'} color={'error'} />
    ) : (
      <CheckIcon fontSize={'small'} color={'success'} />
    );
  };

  let primaryText = `${cc.cityView} (${cc.datesInTheFutureList.length})`;

  return (
    <>
      <ListItemButton onClick={handleClick} dense>
        <ListItemIcon>
          <LocationCityIcon />
        </ListItemIcon>
        <ListItemText>
          {primaryText} {renderIcon()} {renderChip()}
        </ListItemText>
        {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
      </ListItemButton>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div">
          {cc.datesInTheFutureList.map((e) => (
            <CourseCityDateItem
              key={e}
              ccd={e}
              canDelete={canDeleteDates}
              canEdit={canEditDates}
              canEditPublished={canEditPublishedDates}
            />
          ))}
        </List>
      </Collapse>
    </>
  );
};
